<template>
  <v-row class="kbWhite">
    <v-col cols="12">
      <span class="kbDarkBlueText--text text-h5 text-capitalize pl-3">
        {{ $t('sidebar.graphicAspect') }}
      </span>
    </v-col>

    <v-col cols="12">
      <v-divider />
    </v-col>

    <v-col cols="12" md="6" class="px-6 align-self-stretch">
      <div class="d-flex align-center mb-4">
        <v-btn color="kbBlue"
               class="mr-2"
               icon
               small
               @click="setAppTheme(false)">
          <v-icon>
            {{ $vuetify.theme.isDark ? 'mdi-radiobox-blank' : 'mdi-radiobox-marked' }}
          </v-icon>
        </v-btn>
        <span class="kbDarkBlueText--text">
          {{ $t('general.lightTheme') }}
        </span>
      </div>
      <v-img class="elevation-4"
             src="https://storage.googleapis.com/keybe/images/dashboard/light-theme.png"
             style="border-radius: 10px!important; object-fit: cover"
             :alt="$t('general.lightTheme')" />
    </v-col>

    <v-col cols="12" md="6" class="px-6 align-self-stretch">
      <div class="d-flex align-center mb-4">
        <v-btn color="kbBlue"
               class="mr-2"
               icon
               small
               @click="setAppTheme(true)">
          <v-icon>
            {{ $vuetify.theme.isDark ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
          </v-icon>
        </v-btn>
        <span class="kbDarkBlueText--text">
          {{ $t('general.darkTheme') }}
        </span>
      </div>
      <v-img class="elevation-4"
             src="https://storage.googleapis.com/keybe/images/dashboard/dark-theme.png"
             style="border-radius: 10px!important; object-fit: cover"
             :alt="$t('general.darkTheme')" />
    </v-col>

    <v-col cols="12">
      <v-divider />
    </v-col>

    <v-col cols="12" md="6" class="px-6 align-self-stretch">
      <div class="d-flex align-center mb-4">
        <v-btn color="kbBlue"
               class="mr-2"
               icon
               small
               @click="setMenuLocation('sidebar')">
          <v-icon>
            {{ menuLocation === 'sidebar' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
          </v-icon>
        </v-btn>
        <span class="kbDarkBlueText--text">
          {{ $t('general.sidebar') }}
        </span>
      </div>
      <v-img class="elevation-4"
             src="https://storage.googleapis.com/keybe/images/dashboard/sidebar.png"
             style="border-radius: 10px!important; object-fit: cover"
             :alt="$t('general.sidebar')" />
    </v-col>

    <v-col cols="12" md="6" class="px-6 align-self-stretch">
      <div class="d-flex align-center mb-4">
        <v-btn color="kbBlue"
               class="mr-2"
               icon
               small
               @click="setMenuLocation('toolbar')">
          <v-icon>
            {{ menuLocation === 'toolbar' ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
          </v-icon>
        </v-btn>
        <span class="kbDarkBlueText--text">
          {{ $t('general.toolbar') }}
        </span>
      </div>
      <v-img class="elevation-4"
             src="https://storage.googleapis.com/keybe/images/dashboard/toolbar.png"
             style="border-radius: 10px!important; object-fit: cover"
             :alt="$t('general.toolbar')" />
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import UserKeybeExtraData from '@/mixins/UserKeybeExtraData'
export default {
  computed: {
    ...mapState({
      menuLocation: state => state.graphicAspect.menuLocation,
      userKeybe: state => state.auth.userKeybe
    })
  },
  created () {
    this.getGraphicAspectVariablesIndexes()
  },
  data () {
    return {
      isDarkThemeIndex: -1,
      menuLocationIndex: -1
    }
  },
  methods: {
    setAppTheme (value) {
      this.$vuetify.theme.dark = value
      this.updateUserKeybeExtraData(this.isDarkThemeIndex, value)
    },
    getGraphicAspectVariablesIndexes () {
      this.isDarkThemeIndex = this.userKeybeExtraData.map(item => item.field).indexOf('IS_DARK_THEME')
      this.menuLocationIndex = this.userKeybeExtraData.map(item => item.field).indexOf('MENU_LOCATION')
    },
    setMenuLocation (value) {
      this.$store.commit('SET_MENU_LOCATION', value)
      this.updateUserKeybeExtraData(this.menuLocationIndex, value)
    }
  },
  mixins: [UserKeybeExtraData]
}
</script>
